var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm.operateData &&
      _vm.operateData.homePageAd_01 &&
      _vm.operateData.homePageAd_01.switch
        ? _c(
            "el-carousel",
            { attrs: { trigger: "click", height: "80px" } },
            _vm._l(_vm.operateData.homePageAd_01.list, function (item, index) {
              return _c("el-carousel-item", { key: index }, [
                _c("a", {
                  staticClass: "survey",
                  style: {
                    background: `url(${item.src}) no-repeat ${item.backgroundColor}`,
                  },
                  attrs: {
                    href: item.link || "javascript:;",
                    target: item.isNewTabOpen ? "_blank" : "",
                  },
                }),
              ])
            }),
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 16 } }, [
            _c(
              "div",
              { staticClass: "grid-content bg-purple" },
              [_c("data-view"), _c("index-chart")],
              1
            ),
          ]),
          _c("el-col", { attrs: { span: 8 } }, [
            _c(
              "div",
              { staticClass: "grid-content bg-purple" },
              [_c("Ranking"), _c("wait-pay"), _c("wait-back")],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDownload,
            expression: "showDownload",
          },
        ],
        staticClass: "fixed-div",
        on: { click: _vm.closeDownload },
      }),
      _vm.showDownload
        ? [
            _vm.$store.getters.isNew
              ? _c("div", { staticClass: "pic-new" }, [
                  _c("i", {
                    staticClass: "chahao iconfont-erp iconguanbi",
                    on: { click: _vm.closeDownload },
                  }),
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/index-download-new.jpg"),
                      alt: "",
                      srcset: "",
                    },
                  }),
                ])
              : _c("i", { staticClass: "pic" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/index-download.jpg"),
                      alt: "",
                      srcset: "",
                    },
                  }),
                ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }